export default __webpack_public_path__ + "static/media/fasting_drinks@2x.07574c6c.jpg";